// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { $delete, createOrUpdate, get, list } from "./operations.js";
export {
  PureStoragePoliciesDeleteOptionalParams,
  PureStoragePoliciesCreateOrUpdateOptionalParams,
  PureStoragePoliciesGetOptionalParams,
  PureStoragePoliciesListOptionalParams,
} from "./options.js";
